import React from 'react';
import styles from './QRWrapper.scss';
import QRImg from './QRImg';

interface Props {
  url: string;
  name?: string;
}

const QRWrapper: React.StatelessComponent<Props> = ({ url, name }) => (
  <div
    className={`jg-bd jg-bd--solid jg-bd--very-light-grey jg-text--center ${styles['jg-qrwrapper--ticket']}`}
  >
    <div
      className={`jg-space-phml jg-position-relative ${styles['qr-header']}`}
    >
      <div className="jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-pvmd">
        <span className={styles['divider--left']} />
        <span className={styles['divider--right']} />
        <div className="jg-display-flex jg-flex-aic">
          <h2 className="jg-space-mn jg-h4">
            {name ? `${name}'s JustGiving Page` : `JustGiving Page`}
          </h2>
        </div>
      </div>
    </div>
    <QRImg url={url} />
  </div>
);

export default QRWrapper;
